import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SEGMENT_ACTIONS } from '../../../../../../utils/constants/SegmentActionConstants';
import useSegment from '../../../../../../utils/hooks/useSegment';
import { loginWithMobile, loginWithOAuth, clearUserError } from '../../../redux/slices/UserSlice';
import { IOAuthType } from '../../../redux/types';
import { LoginForm, LoginOAuth } from '../../containers';
import {
    StyledContent,
    StyledDivider,
    StyledDividerText,
    StyledErrorText,
    StyledHeading,
    StyledMobileFormContainer,
    StyledOAuthContainer,
    StyledTitle
} from './styles';
import { ILoginPage } from './types';
import { LoopButton, Typography } from '@loophealth/loop-ui-web-library';
import {
    StyledCheckboxContainer,
    StyledCheckboxInput,
    StyledTypographySpan,
    StyledTypographyWrapper
} from '../../containers/LoginForm/styles';
import { redirect } from '../../../../../../utils/common';
import { REDIRECT_URL } from '../../../../../../utils/constants/RedirectConstants';

const LoginPage: React.FunctionComponent<ILoginPage> = ({ title, subTitle }) => {
    const dispatch = useDispatch();
    const trackClick = useSegment('click');
    const trackTask = useSegment('task');
    const userData = useSelector((state: any) => state.user.userData);
    const userMobile = useSelector((state: any) => state.user.userMobile);
    const [isTncChecked, setIsTncChecked] = React.useState(true);
    const loginWithMobileNo = (mobileNumber: string) => {
        dispatch(clearUserError());
        dispatch(loginWithMobile(mobileNumber));
        const segmentAction = SEGMENT_ACTIONS.CLICK.MOBILE_LOGIN;
        trackClick({
            name: segmentAction.name,
            properties: {
                page_title: segmentAction.properties?.page_title,
                mobile: (segmentAction.properties?.mobile as (num: string) => string)(mobileNumber) || '',
                login_status: segmentAction.properties?.login_status
            }
        });
    };
    const oAuthLogin = (type: IOAuthType) => {
        dispatch(clearUserError());
        dispatch(loginWithOAuth({ loginMethod: type }));
    };
    React.useEffect(() => {
        if (!userData.loading && !userData.error && userData.data) {
            const segmentAction = SEGMENT_ACTIONS.TASK.LOGIN_SUCCESS;
            trackTask({
                name: segmentAction.name,
                properties: {
                    login_method: (segmentAction.properties?.login_method as (loginMethod: string) => string)(
                        userData.loginMethodType
                    ),
                    page_title: segmentAction.properties?.page_title,
                    login_status: segmentAction.properties?.login_status,
                    page_url: segmentAction.properties?.page_url,
                    page_id: segmentAction.properties?.page_id
                }
            });
        } else if (!userData.loading && userData.error) {
            const segmentAction = SEGMENT_ACTIONS.TASK.LOGIN_FAIL;
            trackTask({
                name: segmentAction?.name ?? '',
                properties: {
                    login_method: (segmentAction.properties?.login_method as (loginMethod: string) => string)(
                        userData.loginMethodType ?? 'Email'
                    ),
                    page_title: segmentAction.properties?.page_title,
                    login_status: segmentAction.properties?.login_status,
                    page_url: segmentAction.properties?.page_url,
                    page_id: segmentAction.properties?.page_id
                }
            });
        }
    }, [userData]);
    return (
        <StyledContent>
            <StyledTitle>{title}</StyledTitle>
            <StyledHeading>{subTitle}</StyledHeading>
            <StyledOAuthContainer>
                <StyledErrorText>{userData.error && userData.error.message}</StyledErrorText>
                <LoginOAuth signInWithOAuth={oAuthLogin} disabled={!isTncChecked} />
            </StyledOAuthContainer>
            <StyledDivider>
                <StyledDividerText>Or</StyledDividerText>
            </StyledDivider>
            <StyledMobileFormContainer>
                <LoginForm
                    loading={userMobile.loading}
                    showMobile={true}
                    onSubmit={loginWithMobileNo}
                    submitButtonId={'otp-button'}
                    isTncChecked={isTncChecked}
                />
                <StyledCheckboxContainer>
                    <StyledCheckboxInput
                        type="checkbox"
                        checked={isTncChecked}
                        onChange={(e) => setIsTncChecked(e.target.checked)}
                    />
                    <StyledTypographyWrapper>
                        <StyledTypographySpan>
                            <Typography variant="small" color="secondary">
                                By continuing you agree to the
                            </Typography>
                        </StyledTypographySpan>
                        <LoopButton
                            fontWeight={'bold'}
                            size={'small'}
                            variant="text"
                            onClick={() => redirect(REDIRECT_URL.TERMS_CONDITIONS)}
                        >
                            Terms and Conditions
                        </LoopButton>
                        <StyledTypographySpan>
                            <Typography variant="small" color="secondary">
                                and
                            </Typography>
                        </StyledTypographySpan>
                        <LoopButton
                            fontWeight={'bold'}
                            size={'small'}
                            variant="text"
                            onClick={() => redirect(REDIRECT_URL.PRIVACY_POLICY)}
                        >
                            Privacy Policy
                        </LoopButton>
                    </StyledTypographyWrapper>
                </StyledCheckboxContainer>
            </StyledMobileFormContainer>
        </StyledContent>
    );
};

export default LoginPage;
